import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PrimeReactProvider } from 'primereact/api';
import { LayoutProvider } from './layout/context/layoutcontext';
import { ToastContextProvider } from './layout/context/toast-context';
import { NetworkStatusProvider } from './shared/providers/NetworkStatusProvider';
import { ConfirmPopup } from 'primereact/confirmpopup';
import { store } from './store';
import { setupAxiosAuthInterceptors } from './config/setup-axios-auth';
setupAxiosAuthInterceptors();
// PrimeReact CSS
import 'primereact/resources/themes/lara-light-blue/theme.css'; // Theme
import './styles/brand-tokens.css'; // Brand palette + Prime variable overrides
import './styles/prime-brand-overrides.css'; // PrimeReact component brand overrides
import 'primereact/resources/primereact.min.css'; // Core
import 'primeicons/primeicons.css'; // Icons
import 'primeflex/primeflex.css'; // Utility CSS
import './styles/layout/layout.scss';
import './index.scss';
import App from './App';
createRoot(document.getElementById('root')).render(
// <StrictMode>
_jsx(BrowserRouter, { children: _jsx(LayoutProvider, { children: _jsx(Provider, { store: store, children: _jsx(PrimeReactProvider, { value: { ripple: true }, children: _jsx(ToastContextProvider, { children: _jsxs(NetworkStatusProvider, { children: [_jsx(ConfirmPopup, {}), _jsx(App, {})] }) }) }) }) }) })
// </StrictMode>,
);
